<div class="container-fluid main-page main-page-padding">
    <div class="page-title">
        <h2 class="page-header">Trophy Cabinet</h2>
    </div>
    <div class="page-content">
        <div *ngIf="loading" class="text-center">
            <app-loading-wbac-animation></app-loading-wbac-animation>
        </div>
        <div *ngIf="!loading" class="container-fluid">
            <div class="section">
                <div class="section-title streak-title">Streaks</div>
                <div class="shelf">
                    <div *ngFor="let streak of achievements.streakAwards" class="streak">
                        <div class="duration"></div>
                        <div class="icon" [ngClass]="streak.awardedCount > 0 ? '' : 'inactive'" (click)="showCertificate(null, streak, null)"></div>
                        <div class="name">{{ streak.streakName }}</div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="section-title medal-title">Medals</div>
                <div class="shelf">
                    <div *ngFor="let medal of achievements.medals" class="medal">
                        <div class="icon" [ngClass]="medal.isAwarded ? '' : 'inactive'" (click)="showCertificate(null, null, medal)">
                            <div class="new-label" *ngIf="medal.isCurrent">NEW</div>
                        </div>
                        <div class="name">{{ getMedalName(medal) }}</div>
                    </div>
                </div>
            </div>
            <div *ngFor="let group of achievements.badgesGrouped" class="section">
                <div class="section-title badge-title">{{ group.groupName }} Badges</div>
                <div class="shelf">
                    <div *ngFor="let badge of group.visibleBadges" class="badge">
                        <div class="icon" [ngClass]="badge.isAwarded ? '' : 'inactive'" (click)="showCertificate(badge, null, null)"></div>
                        <div class="name">{{ badge.badgeName }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>